import select from 'dom-select';
import bodyEvents from '../../../js/lib/bodyEvents';
import { applyTooltipPosition, manageTooltipState} from '../../../js/lib/tooltipManager';

export const Details = (el) => {
  const ui = {
    el,
    body: select('body', document),
    summary: select('.summary', el),
    content: select('.details__content', el),
    summarySpan: null,
  };

  const summaryTextOpen = ui.el.getAttribute('data-summary-text-open');
  const summaryTextClosed = ui.el.getAttribute('data-summary-text');
  const isTooltip = ui.el.classList.contains('details--tooltip');
  const isLogin = ui.el.classList.contains('login');

  if (summaryTextOpen && ui.summary) {
    ui.summarySpan = select('span', ui.summary);
  }

  const setHash = (id) => {
    if (!id) return;

    const hash = `#${id}`;
    // https://lea.verou.me/blog/2011/05/change-url-hash-without-page-jump/
    if (window.history.pushState) {
      window.history.pushState(null, null, hash);
    } else {
      window.location.hash = hash;
    }
  };

  const killOnEsc = (event) => {
    if (ui.el.hasAttribute('open') && event.key === 'Escape') {
        ui.el.removeAttribute('open');
    }
  };

  const updateSummaryText = () => {
    if (!summaryTextOpen || !ui.summarySpan) return;

    const isOpen = ui.el.hasAttribute('open');
    ui.summarySpan.textContent = isOpen ? summaryTextOpen : summaryTextClosed;
  };

  const handleToggle = () => {
    updateSummaryText();

    // tooltips only
    if (isTooltip) {
    applyTooltipPosition(ui.content);
    }
  };

  const closeLogin = (event) => {
    // Only close if click is outside the details element
    if (!ui.el.contains(event.target)) {
      ui.el.removeAttribute('open');
    }
  }

  const addEvents = () => {
    ui.el.addEventListener('toggle', handleToggle);

    if (ui.summary && ui.el.id) {
      ui.summary.addEventListener('click', () => {
        setHash(ui.el.id);
      });
    }

    if (isTooltip || isLogin) {
      window.addEventListener('resize', manageTooltipState);
      ui.el.addEventListener('keydown', killOnEsc);

      // Use body event service to ensure only one body click listener
      if (ui.body) {
        bodyEvents.add('click', manageTooltipState);
      }

      if (isLogin) {
        ui.body.addEventListener('click', closeLogin);
      }
    }
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default Details;
